/**
@license
Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/* <link rel="import" href="../bower_components/post-flight-verification/post-flight-validator.html"> */
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import "@polymer/polymer/polymer-legacy.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import "./registration.js";
import "./shared-styles.js";
import { PolymerElement } from "@polymer/polymer/polymer-element.js";
class SignUpPage extends PolymerElement {
    static get template() {
        return html `
            <style include="shared-styles">
                :host {
                    display: block;
                    padding: 10px;
                }
            </style>

            <div class="card">
                <!--<div class="circle">4</div>-->
                <!--<demo-element api-base-url="{{apiBaseUrl}}"></demo-element>-->
                <sign-up></sign-up>
            </div>
        `;
    }
    static get is() {
        return "sign-up-page";
    }
    static get properties() {
        return {
            apiBaseUrl: {
                type: String,
                notify: true,
            },
        };
    }
}
window.customElements.define(SignUpPage.is, SignUpPage);
//# sourceMappingURL=sign-up-page.js.map